import React, { Component } from "react";
import "w3-css/3/w3.css";

class FromCubicFootButton extends Component {
  handleClickButon = buttonId => {
    this.props.ftUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Cubic Foot to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CubicInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <LiterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromCubicInchButton extends Component {
  handleClickButon = buttonId => {
    this.props.inUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Cubic Inch to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CubicFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <LiterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromCubicMeterButton extends Component {
  handleClickButon = buttonId => {
    this.props.mUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Cubic Meter to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CubicFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <LiterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromCubicMileButton extends Component {
  handleClickButon = buttonId => {
    this.props.miUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Cubic Mile to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CubicFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <LiterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromCubicYardButton extends Component {
  handleClickButon = buttonId => {
    this.props.ydUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Cubic Yard to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CubicFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <LiterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class FromLiterButton extends Component {
  handleClickButon = buttonId => {
    this.props.lUnit(buttonId);
  };
  render() {
    return (
      <div className="w3-margin-small w3-padding-small w3-white">
        <h3>From Liter to </h3>
        <div className="w3-container">
          <div className="w3-margin">
            <p>
              <CubicFootButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicInchButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMeterButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicMileButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
              <CubicYardButton
                id={this.props.id}
                clickedbutton={this.handleClickButon}
              />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

class CubicFootButton extends Component {
  handleUpButton = () => {
    let name = "ft";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="cubicfoot"
        >
          Cubic Feet
        </button>
      </span>
    );
  }
}

class CubicInchButton extends Component {
  handleUpButton = () => {
    let name = "in";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="cubicinch"
        >
          Cubic Inches
        </button>
      </span>
    );
  }
}

class CubicMeterButton extends Component {
  handleUpButton = () => {
    let name = "m";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="cubicmeter"
        >
          Cubic Meters
        </button>
      </span>
    );
  }
}

class CubicMileButton extends Component {
  handleUpButton = () => {
    let name = "mi";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="cubicmile"
        >
          Cubic Miles
        </button>
      </span>
    );
  }
}

class CubicYardButton extends Component {
  handleUpButton = () => {
    let name = "yd";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="cubicyard"
        >
          Cubic Yards
        </button>
      </span>
    );
  }
}

class LiterButton extends Component {
  handleUpButton = () => {
    let name = "l";
    this.props.clickedbutton(this.props.id + name);
  };
  render() {
    return (
      <span className="w3-tag w3-white w3-large w3-margin-bottom">
        <button
          className="w3-btn w3-light-grey"
          onClick={this.handleUpButton}
          name="liter"
        >
          Liters
        </button>
      </span>
    );
  }
}

export {
  FromCubicFootButton,
  FromCubicInchButton,
  FromCubicMeterButton,
  FromCubicMileButton,
  FromCubicYardButton,
  FromLiterButton
};
